import apiWithAuth from './apiWithAuth';

const ADMIN_V1 = '/v1/admin';

export function listBloggers(params) {
  return apiWithAuth.get(`${ADMIN_V1}/blogger-ops/bloggers`, { params });
}

export function getBloggerStats(id) {
  return apiWithAuth.get(`${ADMIN_V1}/blogger-ops/blogger/${id}/stats`);
}

export function assignShopsToBlogger(body) {
  return apiWithAuth.post(`${ADMIN_V1}/blogger-ops/assign-shop`, body);
}

export function reassignBloggerShop(body) {
  return apiWithAuth.patch(`${ADMIN_V1}/blogger-ops/reassign-shop`, body);
}

export function listContentTasks(params) {
  return apiWithAuth.get(`${ADMIN_V1}/content-tasks`, { params });
}

export function patchContentTask(taskId, body) {
  return apiWithAuth.patch(`${ADMIN_V1}/content-tasks/${taskId}`, body);
}

export function listBlogPosts(params) {
  return apiWithAuth.get(`${ADMIN_V1}/blogger-ops/posts`, { params });
}

export { searchShopsForPicker, getAdminShop } from './fieldOpsAdminApi';
